import script from "./createOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./createOrder.vue?vue&type=script&lang=ts&setup=true"

import "./createOrder.vue?vue&type=style&index=0&id=fdcf7ad2&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdcf7ad2"]])

export default __exports__